export default __webpack_public_path__ + "a76d391.png";